var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('companies.commissions_alert'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }